module.exports = __webpack_public_path__ + "img/bg-1.62187089.jpg";